module.exports = __webpack_public_path__ + "img/0deg.448ac807.svg";